import {
  SETTEXT,
  SETPHONEMESSAGE,
  SETSMSMESSAGE,
  SETEMAILMESSAGE,
} from './actionType'

// initialState shows what we are going to change
const initialState = {
  // empty text field
  inputText: '',
  inputPhoneMessage: '',
  inputSMSMessage: '',
  inputEmailMessage: '',
  // empty data field
  // data: null,
}

// Checks the type of the action and returns the appropriate state
export default function messageCreateReducer(state = initialState, action) {
  switch (action.type) {
    case SETTEXT:
      // First 2 params copy over empty data, third param overrides
      return Object.assign({}, state, {
        inputText: action.data,
      })
    case SETPHONEMESSAGE:
      // First 2 params copy over empty data, third param overrides
      return Object.assign({}, state, {
        inputPhoneMessage: action.data,
      })
    case SETSMSMESSAGE:
      // First 2 params copy over empty data, third param overrides
      return Object.assign({}, state, {
        inputSMSMessage: action.data,
      })
    case SETEMAILMESSAGE:
      // First 2 params copy over empty data, third param overrides
      return Object.assign({}, state, {
        inputEmailMessage: action.data,
      })
    default:
      // returns state as is without changes
      return state
  }
}
